/**
 * デジタルサイネージ表示設定管理一覧グリッド
 * @module app/signage/SignageAdminPageGrid
 */
define([
    'module',
    'dojo',
    'dojo/_base/declare',
    'dojo/on',
    'idis/view/grid/IdisGrid',
    'idis/view/grid/IdisSelector',
    'idis/util/DateUtils',
    'idis/view/grid/helper',
    'dojo/dom-style',
    'idis/model/UserInfo'
], function(module, dojo, declare, on, IdisGrid, IdisSelector, DateUtils, helper, domStyle, UserInfo) {
    return declare(module.id.replace(/\//g, '.'), [IdisGrid, IdisSelector],
        /** @lends module:app/signage/SignageAdminPageGrid~SignageAdminPageGrid# */ {

        constructor: function () {
            /**
             * 各列の定義
             * @type {Object[]}
             */
            this.columns = [
                {
                    field: 'checkbox',
                    label: '選択',
                    selector: 'checkbox',
                },
                {field: 'screenId', label: '画面ID', sortable: true},
                {field: 'displayTypeName', label: 'ディスプレイ種別', sortable: false,
                    renderCell: function(item){
                        var actions = dojo.create('div');
                        var gridNode = this.grid.domNode;
                        if (item.displayType === 15) {
                            var link = dojo.create('a', {href: '#'});
                            link.innerHTML = item.displayTypeName;
                            link.onclick = function() {
                                on.emit(gridNode, 'showMapSettingPage', {item: item});
                            };
                            actions.appendChild(link);
                        } else {
                            actions.innerHTML = item.displayTypeName;
                        }
                        return actions;
                    }
                },
                {field: 'displayName', label: 'ディスプレイ名称', sortable: false},
                {field: 'updFreq', label: '更新頻度(秒)', sortable: true},
                {field: 'remarks', label: '備考', sortable: false},
                {field: 'updTimestamp', label: '最終更新日時', sortable: true,
                    formatter: function(updTimestamp){
                        return updTimestamp ? DateUtils.format(updTimestamp) : '-';
                    }
                }
            ];
            // 管理ユーザ、県・危機管理・管理ユーザ、県・危機管理・一般ユーザの場合は「詳細ボタン」を表示させる
            // 役割を取得
            var role = UserInfo.getRoleCd();
            if (UserInfo.isSysAdmin() || role === 'R01011' || role === 'R01012') {
                this.columns.splice(1, 0, helper.buttonColumn('detail', '詳細'));
            }

            this.inherited(arguments);
        },

    });
});
